<app-alert></app-alert>
<section class="panel panel-default">
    <div class="card-header">
        <title>Proxy</title>
        <span class="cat__core__title">
            <strong id="pageTitle">Register of Proxy</strong>
        </span>

        <span style="float: right">
            <!-- <a routerLink="/proxyList"> -->
                <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
                    <i class=" fa fa-chevron-circle-left"></i>
                    Back
                </button>
            <!-- </a> -->
        </span>

        <!-- <span style="float:right">
                <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="!addBtn">
                  <span>
                    <i class="fa fa-save"></i>Generate Output </span>
                </button>
        </span> -->
       
        <meta charset="utf-8">

    </div>
    <div>
        <form [formGroup]='proxyForm' (document:click)="a.close()">
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Name of the Member appointing the Proxy</label>
                        <span _ngcontent-c2="" style="color: red;">*</span>
                        <!-- <div class="form-group">
                            <input type="text" [formControl]="proxyForm.controls['nameOfTheMentor']"
                                class="form-control">
                            <div *ngIf="proxyForm.controls['nameOfTheMentor'].hasError('pattern')"
                                class="form-control-error-custom">
                                Name of the Member appointing the Proxy is invalid
                            </div>
                        </div> -->
                          <select [formControl]="proxyForm.controls['nameOfTheMentor']" class="form-control" (change)="getsh2FormDetails($event, proxyForm.controls.nameOfTheMentor.value)" style="padding: 6px;"> 
                                <option value="">Select any one</option>  
                                <option *ngFor="let item of nameOfMemberList; let i = index;" [attr.data-mgt1id]="item.MGT1_id" value="{{item.nameOfMember}}">  
                                    {{item.nameOfMember}}
                                </option> 
                          </select>
                    </div>
                 
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Folio Number</label>
                        <span _ngcontent-c2="" style="color: red;">*</span>
                        <div class="form-group">
                            <input [formControl]="proxyForm.controls['folioNumber']" class="form-control" readonly>
                            <div *ngIf="proxyForm.controls['folioNumber'].hasError('required') && proxyForm.controls['folioNumber'].touched"
                                class="form-control-error-custom">
                                Folio Number is required
                            </div>
                            <div *ngIf="proxyForm.controls['folioNumber'].hasError('pattern') "
                                class="form-control-error-custom">
                                Folio Number is invalid
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Number of Shares held by the Member</label>
                        <div class="form-group">
                            <input [formControl]="proxyForm.controls['numberOfShares']" (keydown)="onlyNumber($event)"
                                class="form-control" readonly>
                        </div>
                    </div>
                   
                </div>

                <div class="row">
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Demat Account Number</label>
                        <div class="form-group">
                            <input type="text" [formControl]="proxyForm.controls['dematAccountNumber']"
                                 class="form-control">
                            <div *ngIf="(proxyForm.controls['dematAccountNumber'].hasError('pattern') || proxyForm.controls['dematAccountNumber'].hasError('minlength') || proxyForm.controls['dematAccountNumber'].hasError('maxlength')) && proxyForm.controls['dematAccountNumber'].touched"
                                class="form-control-error-custom">
                                Demat Account Number is invalid
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Client ID</label>
                        <div class="form-group">
                            <input [formControl]="proxyForm.controls['clientId']" class="form-control">
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Dp Id</label>
                        <div class="form-group">
                            <input type="text" [formControl]="proxyForm.controls['dpId']" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Name of the Proxy (ies) Appointed</label>
                        <span _ngcontent-c1="" style="color: red;">*</span>
                        <div class="form-group">
                            <input [formControl]="proxyForm.controls['nameOfProxy']" class="form-control">
                            <div *ngIf="proxyForm.controls['nameOfProxy'].hasError('pattern')"
                                class="form-control-error-custom">
                                Name of the Proxy (ies) Appointed is invalid
                            </div>
                            <div *ngIf="proxyForm.controls['nameOfProxy'].hasError('required') && proxyForm.controls['nameOfProxy'].touched"
                                class="form-control-error-custom">
                                Name of the Proxy (ies) Appointed is required
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Date of receipt of Proxy Form
                            <span _ngcontent-c2="" style="color: red;">*</span></label>

                        <div class="input-group" (click)="$event.stopPropagation()">
                            <input class="form-control" [formControl]="proxyForm.controls['dateOfReceiptOfProxy']"
                                [(ngModel)]="dateOfReceiptOfProxyModel" style="padding:6px;z-index: 0;"
                                placeholder="dd-mm-yyyy" name="dateOfReceiptOfProxy" ngbDatepicker #a="ngbDatepicker"
                                (click)="a.toggle();">
                            <button class="input-group-addon" (click)="a.toggle();" type="button">
                                <span class="fa fa-calendar"
                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button>
                        </div>
                        <div *ngIf="proxyForm.controls['dateOfReceiptOfProxy'].hasError('required') && proxyForm.controls['dateOfReceiptOfProxy'].touched"
                            class="form-control-error-custom">
                            Date of receipt of Proxy Form is required
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Time of receipt of Proxy Form </label>
                        <!-- <div class="form-group">
                            <input [formControl]="proxyForm.controls['timeOfReceipt']" class="form-control">
                        </div> -->
                        <div class="input-group">
                            <input type="text" class="form-control timepicker-init"
                                [formControl]="proxyForm.controls['timeOfReceipt']" id="fromTimeOfInspection"
                                (focusout)="getTimeOfInspection()">
                            <span class="input-group-addon">
                                <i class="icmn-clock"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Number of Valid Proxies</label>
                        <div class="form-group">
                            <input [formControl]="proxyForm.controls['numberOfValidProxies']"
                                (keydown)="onlyNumber($event)" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Number of Invalid Proxies</label>
                        <div class="form-group">
                            <input [formControl]="proxyForm.controls['numberOfInvalidProxies']"
                                (keydown)="onlyNumber($event)" class="form-control">
                        </div>
                    </div>
                    <div class=" form-group col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Remarks: Reason for rejection of proxy, if any</label>
                        <textarea class="form-control" [formControl]="proxyForm.controls['remarks']"
                            maxlength="200"></textarea>

                    </div>
                </div>
            </div>
            <div class="card-footer" align="right">
                   
                <!-- <div class="form-actions" style="text-align: right"> -->
                <button class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="saveProxy()" type="button"
                    [disabled]="!proxyForm.valid || disabledOnclick" *ngIf="addBtn">Save</button>

                    <!-- <button class="btn btn-sm btn-primary" (click)="generateOutput()" type="button" *ngIf="!addBtn">
                        <span>
                          <i class="fa fa-save"></i>Generate Output </span>
                      </button> -->


                <button class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="updateProxy()" type="button"
                    [disabled]="!proxyForm.valid || disabledOnclick" *ngIf="!addBtn">Update</button>
                <!-- </div> -->
            </div>
        </form>
    </div>
</section>
<app-alert></app-alert>